import { Application } from "@hotwired/stimulus"
import HwComboboxController from "@josefarias/hotwire_combobox"

const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus   = application

// Register Hotwire Combobox controller
application.register("hw-combobox", HwComboboxController)

export { application }
